import FormDataParser from 'utils/form_data_parser';

export default class FilterFormTracker extends FormDataParser {
  constructor($form) {
    super($form);
    this.$inputs = $(this.inputSelector, this.$form);
    this.$inputs.toArray().forEach(el => this.change(el, false));
  }

  parse() {
    return Object.keys(this.summary).reduce((prev, curr) => {
      return {
        ...prev,
        [`Form Label: ${this.summary[curr].label}`]: this.summary[curr].display
      };
    }, {});
  }

  json() {
    return Object.keys(this.summary).reduce((prev, curr) => {
      return {
        ...prev,
        [`${this.summary[curr].name.replace('[]', '')}`]:
          this.summary[curr].display
      };
    }, {});
  }
}
